// WebDoc Services Data
export const services = [
  {
    id: 1,
    name: "Wallet Protection Plan",
    type: "Insurance",
    status: "Active",
    pricePerMonth: 99,
    totalDeducted: 297,
    maxCoverage: "Rs. 15,000",
    subscribedOn: "15 May 2024",
    icon: "🛡️",
    color: "#0099CC",
  },
  {
    id: 2,
    name: "Mobile Screen Protection",
    type: "Insurance",
    status: "Active",
    pricePerMonth: 49,
    totalDeducted: 147,
    maxCoverage: "Rs. 7,500",
    subscribedOn: "10 Apr 2024",
    icon: "📱",
    color: "#2ecc71",
  },
];


export const cancelReasons = [
  { id: "no_need",       labelEn: "No Longer Needed",             labelRu: "Ab Zaroorat Nahi" },
  { id: "expensive",     labelEn: "Too Expensive",                labelRu: "Zyada Mehenga Hai" },
  { id: "not_aware",     labelEn: "Wasn't Aware of This Service", labelRu: "Mujhe Is Service Ka Pata Nahi Tha" },
  { id: "not_expected",  labelEn: "Service Wasn't as Expected",   labelRu: "Service Expected Nahi Thi" },
  { id: "other_service", labelEn: "Using Another Service",        labelRu: "Dusri Service Use Kar Raha Hoon" },
  { id: "other",         labelEn: "Other Reason",                 labelRu: "Koi Aur Wajah" },
];
